import { render, staticRenderFns } from "./yiqing.vue?vue&type=template&id=6c4e74f8&scoped=true&"
import script from "./yiqing.vue?vue&type=script&lang=js&"
export * from "./yiqing.vue?vue&type=script&lang=js&"
import style0 from "./yiqing.vue?vue&type=style&index=0&id=6c4e74f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4e74f8",
  null
  
)

export default component.exports